import { t } from '@/i18n';

/** The browser tab text for a route's `meta.title` (a message key): "<page> - CargoXS Airside", or the app's name. */
export function pageTitle(title?: string): string {
    return title ? t('layout.pageTitle', { page: t(title) }) : t('layout.appTitle');
}
